<template>

  <div class="feedback-modal" :style="style">

    <div class="feedback-modal__content">
      <slot></slot>

      <div class="feedback-modal__x-button" @click="close">X</div>
    </div>

  </div>

</template>

<script>

export default {
  data () {
    return {
      style: {
        display: 'none'
      }
    }
  },
  methods: {
    open () {
      document.activeElement.blur()
      this.style.display = 'block'
      window.addEventListener('click', this.handleDocumentClick, true)
    },
    close () {
      this.style.display = 'none'
      window.removeEventListener('click', this.handleDocumentClick, true)
      this.$emit('dismiss')
      console.log('feedbackModal dismiss')
    },
    handleDocumentClick (e) {
      if (!this.$el.getElementsByClassName('feedback-modal__content')[0].contains(e.target)) {
        this.close()
      }
    }
  }
}

</script>

<style lang="scss">

.feedback-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &__content {
    position: absolute;
    top: 300px;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    width: 500px;
    height: auto;
    padding: 40px 80px;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.6);
    color: black;
    font-size: 17px;
    line-height: 24px;
  }

  &__x-button {
    position: absolute;
    top: 0px;
    right: 0px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    height: 34px;
    width: 34px;
    border-radius: 50%;
    background-color: black;
    color: white;
    font-size: 12px;
    transform: translateX(50%) translateY(-50%);
    cursor: pointer;
    font-size: 16px;
  }

  & .action-button {
    background-color: rgb(198, 204,209);
  }

}


</style>



// WEBPACK FOOTER //
// FeedbackModal.vue?3d862335